export default __webpack_public_path__ + "static/anne_frank-3a50b046daae13a10a5723d5a3f49bf4.jpg";